import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { DictionaryContextOperationsResponse } from './dictionary-context-operations.response';

@jsonObject
export class DictionaryCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly position!: number;

  @jsonMember(String)
  public readonly label!: string;

  @jsonMember(String)
  public readonly slug?: Nillable<string>;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(DictionaryContextOperationsResponse)
  public readonly contextOperations!: DictionaryContextOperationsResponse;
}
